import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { propAny, propChildren, propStr, } from '../../../../helpers/custom-prop-types';
import Image from '../../Common/Image';
const PdfImageModalThumbnailSliderTopItem = (props) => {
    const { customChildren, item, url } = props;
    return (_jsxs(_Fragment, { children: [_jsx("li", Object.assign({ className: 'slide-item' }, { children: _jsx(Image, { allowContextMenu: false, alt: '', isObjectFit: true, src: url }) })), customChildren && cloneElement(customChildren, { item })] }));
};
PdfImageModalThumbnailSliderTopItem.propTypes = {
    customChildren: propChildren(),
    item: propAny().isRequired,
    url: propStr().isRequired,
};
PdfImageModalThumbnailSliderTopItem.defaultProps = {
    customChildren: undefined,
};
export default PdfImageModalThumbnailSliderTopItem;
